module.exports = __webpack_public_path__ + "media/shared/images/apple-touch-icon-iphone-retina-4364432d61f1f1d197072dafa2b302b8.png";